<template>
    <vTerminalAuthorizationComponent :postList="postList" v-if="flag"></vTerminalAuthorizationComponent>
</template>
<script>
import vTerminalAuthorizationComponent from '../../listComponent/basicdata/terminalAuthorization/terminalAuthorizationComponent.vue';
export default {
    name: 'terminalAuthorization',
    components: {
        vTerminalAuthorizationComponent
    },
    data() {
        return {
            postList: {
                headerTitle: false,
                code: true,
                approval_status: true,
                status: true,
                business_rid: true,
                terminal_rid: true,
                product_rid: true,
                date: true,
                representative_rid: true,
                searchBtn: true,
                resetBtn: true,
                downFileBtn: true,
                setBtn: true,
                addBtn: true,
                matchBtn: true
            },
            flag: false
        };
    },
    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>